var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_790_10901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3584 1.66211C8.47617 1.68597 8.585 1.74481 8.6709 1.83203L12.7549 5.97949L12.8301 6.07324C12.8522 6.10678 12.8714 6.14228 12.8867 6.17969L12.9219 6.2959C12.9297 6.33555 12.9336 6.37638 12.9336 6.41699C12.9336 6.45739 12.9296 6.49766 12.9219 6.53711L12.8867 6.65332C12.8714 6.69074 12.8522 6.72621 12.8301 6.75976L12.7549 6.85351L8.6709 11.001C8.55643 11.1172 8.40085 11.1836 8.23828 11.1836C8.11662 11.1835 7.99893 11.1464 7.89942 11.0791L7.80567 11.001C7.69153 10.8848 7.62799 10.7279 7.62793 10.5645C7.62793 10.4008 7.69131 10.2432 7.80567 10.127L10.8516 7.03515L0.796876 7.03516C0.675185 7.03507 0.557485 6.99806 0.458009 6.93066L0.365235 6.85352C0.251012 6.7375 0.186609 6.5804 0.186524 6.41699C0.186524 6.25347 0.250936 6.09559 0.365235 5.97949L0.458009 5.90234C0.557452 5.83501 0.675246 5.79793 0.796876 5.79785L10.8506 5.79785L7.80566 2.70605C7.69151 2.58996 7.62804 2.43294 7.62793 2.26953C7.62793 2.10593 7.69138 1.94823 7.80566 1.83203L7.89941 1.75488C7.99899 1.68747 8.11649 1.65045 8.23828 1.65039L8.3584 1.66211Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_790_10901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNext);
export default __webpack_public_path__ + "static/media/iconNext.5d8be4f56d562d345f34c15e0efbd154.svg";
export { ForwardRef as ReactComponent };